import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';

interface searchOption {
  type:string,
  obj:Object[],
  title:string,
  score:number,
}

@Component({
  selector: 'g10-rostering-global-search',
  templateUrl: './rostering-global-search.component.html',
  styleUrls: ['./rostering-global-search.component.css']
})
export class RosteringGlobalSearchComponent implements OnInit {

  @Input() id: string = "routeGlobalSearch";
  @Output() result = new EventEmitter();
  @Output() focused = new EventEmitter();

  public searchVal:string = '';
  public menuShowed:boolean = false;
  public searchProcess:boolean =  false;
  public srchBtnClicked:boolean = false;
  public enableNoData:boolean = false;

  public searchBadges = {
    'route': {
      name: 'Route',
      tooltip:'Route',
      bgColor: '#e3e2ff',
      color: '#00000099',
    },
    'employee': {
      name: 'Employee',
      tooltip:'Employee',
      bgColor: '#6c50a966',
      color: "#00000099",
    },
    "vehicle": {
      name: 'Vehicle',
      tooltip:'Vehicle',
      bgColor: "#93c25a",
      color: "#00000099"

    },
    'pickuppoint': {
      name: 'Pickup Point', //PP
      tooltip:'Pickup Point',
      bgColor: '#20C99766',
      color: '#00000099'

    }
  };

  public gblSearchOptions:searchOption[] = [];

  public searchChangeObserver: any;

  constructor(public api:ApiService,public comService:CommonServices) { }

  ngOnInit(): void {
    document.body.addEventListener('click', ($event: any) => {
      const srchClassKeys = Object.keys($event.target.classList);
      const srchClass = $event.target.classList[srchClassKeys[0]];
      if (
        srchClass == undefined ||
        srchClass.includes('globalSearchModule') == false
      ) {
        this.removeDropdown();
      }
    });
  }

  onSearchChange() {
    // this.removeDropdown();
    let search = this.searchVal.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
    if(search==''){
      this.emitFocus(false);
      this.emitResult({});
    }
    else{
      this.enableNoData = false;
      if (!this.searchChangeObserver) {
        new Observable(observer => {
          this.searchChangeObserver = observer;
        }).pipe(
            debounceTime(1000), // wait 1000ms after the last event before emitting last event
            distinctUntilChanged()) // only emit if value is different from previous value
          .subscribe((term: any) => {
            // your code here
            if(this.srchBtnClicked){
              this.globalSearchFn(this.searchVal);
            }
            setTimeout(() => {
              // document.getElementById('globalSearchMenu').classList.add('show');
              // document.getElementById(this.id).classList.add('show');
            }, 500);
          });
      }else{
        if(this.srchBtnClicked){
          if(this.gblSearchOptions.length<=0){
            this.enableNoData = true;
          }else{
            this.openDropdown();
          }
        }
      }
  
      this.searchChangeObserver.next(this.searchVal);
    }

  }

  async globalSearchFn(searchval){
    let options:searchOption[];
    this.gblSearchOptions = [];
    this.enableNoData = false;
    this.searchProcess = true;
    let routes:any = await this.routeAPIsearch('route','title',searchval,'transportMangerRouteSearch','title').catch((err)=>{ console.log(err); return [];})
    let pickupPoints:any = await this.routeAPIsearch('pickuppoint','ppName',searchval,'transportManagerRoutePPSearch','ppName').catch((err)=>{ console.log(err); return [];})
    let employees:any = await this.routeAPIsearch('employee','search',searchval,'transportManagerRouteEmpSearch','empName').catch((err)=>{ console.log(err); return [];})
    let vehicles:any = await this.routeAPIsearch('vehicle','vehicle',searchval,'transportManagerRouteVehSearch','vehicle').catch((err)=>{ console.log(err); return [];})
    this.enableNoData = true;

    options = [...routes,...vehicles,...pickupPoints,...employees];

    let dropdownOptions:any = await this.checkSimilarity(options);
    dropdownOptions = dropdownOptions.sort((a,b)=>a.score-b.score).slice(0,10);
    this.gblSearchOptions = [ ...dropdownOptions];
    this.searchProcess = false;
    this.openDropdown();
  }

  checkSimilarity(data:searchOption[]){
    return new Promise((resolve,reject)=>{
      try{
        let result:any =  [...data];
        result.map(async (item,index)=>{
          let obj = { ...item};
          let score:any = 1;
          await this.comService.strSimilarity(item.title,this.searchVal).then((val)=>{
            score = val;
          }).catch((err)=>{console.log(err)});

          obj['score'] = score;
          result[index] = obj;
        })
        resolve(result);
      }catch(err){
        console.log(err);
        resolve(data);
      }
    })
  }

  clearSearch(){
    // this.searchVal = '';
    this.removeDropdown();
    this.focused.emit(false);
  }

  clearEmptyMenu(){
    if(this.gblSearchOptions==undefined || this.gblSearchOptions.length<=0){
      this.removeDropdown();
    }
  }

  removeDropdown(){
    let gblSrchBtn = document.getElementById('globalSearchBtn');
    let gblSrchMenu =  document.getElementById('globalSearchMenu');
    if(gblSrchBtn)
      gblSrchBtn.classList.remove('show');
    if(gblSrchMenu)
      gblSrchMenu.classList.remove('show');
    this.menuShowed = false;
  }
  openDropdown(){
    let gblSrchBtn = document.getElementById('globalSearchBtn');
    let gblSrchMenu =  document.getElementById('globalSearchMenu');
    if(gblSrchBtn)
      gblSrchBtn.classList.add('show');
    if(gblSrchMenu)
      gblSrchMenu.classList.add('show');
    this.menuShowed = true;
    // this.emitFocus(true)
  }



  searchBtnClick(){
    if(!this.srchBtnClicked){
      this.searchProcess = true;
    }
    if(this.srchBtnClicked) this.enableNoData = true;
    if(this.searchVal=='' || this.gblSearchOptions.length <= 0){
      this.searchChangeObserver = undefined;
    }
    this.onSearchChange();
    // if(this.searchVal!='') this.openDropdown();
    document.getElementById(this.id).focus();
    this.srchBtnClicked = true;
      // if(!this.menuShowed){
      //   this.emitFocus(true)
      // }
    
    // if(this.menuShowed){
    //   this.clearSearch();
    // }else{

    //   this.onSearchChange();
    //   this.emitFocus(true)
    // }
  }

  inputBtnClick(){
    // if(this.menuShowed){
    //   this.removeDropdown();
    // }
    // else{
    // }
    this.searchBtnClick();
  }

  routeAPIsearch(srchType,searchKey,searchVal,apiMethod,titleKey){
    return new Promise((resolve,reject)=>{
      let obj = {};
      if (searchVal) obj[searchKey] = searchVal;
      try{
        this.api[apiMethod](obj).then(async (res: any) => {
          if (res.status == 'success') {
            if (res.data && res.data.length > 0) {
              let result:searchOption[] = [];
              
              await this.apiDataProcess(srchType,res.data,titleKey).then((res:any)=>{
                result = res
              }).catch((err)=>{ console.log(err)});

              resolve(result);
            }else{
              reject([]);
            }
          }else reject([]);
        }).catch((err)=>{
          console.log(err);
          reject([]);
        });
      }catch(err){
        console.log(err);
        reject([])
      }
    })

  }

  apiDataProcess(srchType,data,key){
    return new Promise((res,rej)=>{
      try{
        let returnObj:any = {};
        data.map((item)=>{
          let obj:searchOption = { 
          title: item[key] ? item[key] : '',
          type: srchType,
          obj: [{ ...item}],
          score:1, 
          };

          if(returnObj[obj['title']]){
            returnObj[obj.title]['obj'] = [ ...returnObj[obj.title]['obj'],...obj['obj']];
          }else{
            returnObj[obj.title] = obj;
          }
          });     
        res(Object.values(returnObj));
      }catch(err){
        res([]);
      }
    })
  }

  emitFocus(val:boolean){
    if(!this.menuShowed){
      this.focused.emit(val);
    }
    if(!val && this.searchVal==''){
      this.emitResult({});
    }
  }

  srchFocus(){
    // if(this.menuShowed) this.removeDropdown();
    if(this.srchBtnClicked){
      if(this.searchVal==''){
        this.removeDropdown();
      }
      else{
        this.searchProcess = true;
        this.enableNoData = false;
        this.onSearchChange();
      }
    }
    // this.emitFocus(false);
  }
 
  emitResult(optionObj){
    this.removeDropdown();
    this.result.emit(optionObj)
  }

}
